import React from 'react';
import { cn } from '../../lib/cn';
interface AvatarProps {
  name: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
const sizes = {
  sm: 'h-7 w-7 text-[11px]',
  md: 'h-9 w-9 text-xs',
  lg: 'h-14 w-14 text-lg'
};
function initials(name: string) {
  return name.replace(/(Dr\.?|Mr\.?|Ms\.?|Mrs\.?)/gi, '').trim().split(/\s+/).slice(0, 2).map(p => p[0]).join('').toUpperCase();
}
const palette = ['bg-brand-100 text-brand-700', 'bg-sky-100 text-sky-700', 'bg-violet-100 text-violet-700', 'bg-amber-100 text-amber-700', 'bg-rose-100 text-rose-700'];
export function Avatar({
  name,
  src,
  size = 'md',
  className
}: AvatarProps) {
  const color = palette[name.length % palette.length];
  if (src) {
    return <img src={src} alt={name} className={cn('rounded-full object-cover ring-2 ring-white', sizes[size], className)} data-id="element-383" data-mp="3sei85gih7hep" />;
  }
  return <span className={cn('inline-flex items-center justify-center rounded-full font-semibold ring-2 ring-white', sizes[size], color, className)} aria-hidden data-id="element-384" data-mp="3nh9o1adrp3at">
      {initials(name)}
    </span>;
}